// extracted by mini-css-extract-plugin
export default {"f":"b76682ddac","main":"_4894f29082","btn":"_1f7bbb82f3","w":"f8a2abeb79","h":"_45f24ba636","lh25":"_192f58d3f8","wb":"cc9d22c2e4","b":"_3ba179932a","bx":"_3dcf3108e4"};